/**
 * List of charge statuses that indicate a charge has been paid at some point.
 */
export const CHARGE_HAS_COUPON_REDEEMED_STATUSES = [
  'paid',
  'partially_paid',
  'unpaid',
  'refunded',
  // Canceled does not exist as a "status" on the Charge model however it gets transformed
  // Into orderStatus in our filters
  'canceled',
  'partial_refund',
];

/**
 * List of subscription statuses that indicate a subscription has been paid at some point.
 */
export const SUBSCRIPTION_HAS_COUPON_REDEEMED_STATUSES = [
  'trialing',
  'scheduled',
  'active',
  'past_due',
  'canceled',
  'unpaid',
  'completed',
];
